export default __webpack_public_path__ + "b90165ed415edc54603b8035b87f39fa.svg";